import type { VirtualGrid } from 'plp/types/Catalog'

import styles from './GroupHeader.module.scss'

export function GroupHeader({
	group,
}: {
	group: VirtualGrid
}): React.ReactNode {
	const DescriptionTag = group.title ? 'h3' : 'h2'
	const notEmpty = (s?: string): boolean => !!s && s !== ''
	const hasTitleOrSubtitle = notEmpty(group.title) || notEmpty(group.subtitle)
	return hasTitleOrSubtitle ? (
		<div className={styles.header}>
			{group.title && <h2>{group.title}</h2>}
			{group.subtitle && (
				<DescriptionTag className={styles.subtitle}>
					{group.subtitle}
				</DescriptionTag>
			)}
		</div>
	) : null
}
